import { useContext } from 'react'
import { Tabs, TabPane, FormContext } from '@frontend/design_system'
import { ImportantIcon } from 'ui/icons'
import { ContextType } from 'ui/molecules/Form/types'
import { LeftSideProps } from './types'
import { CAR_TABS } from 'texts/vehicleDetails'
import {
  DRIVER_AGE_RANGE_FIELDS,
  VEHICLE_DETAILS_FIELDS,
} from '../../constants'
import styles from './styles.module.scss'

export const LeftSide = ({
  activeKey,
  changeActiveKey,
  tabs,
  driverAgeError,
}: LeftSideProps) => {
  const { errors } = useContext<ContextType>(FormContext)

  const checkTabError = (fields: { [key: string]: string }) => {
    const formErrors = Object.entries(errors).map(([key, value]) => ({
      id: key,
      value,
    }))

    const tabErrors = formErrors.filter((item) => item.value && fields[item.id])
    return !!tabErrors.length
  }

  const tabErrors = {
    [CAR_TABS.DETAILS]: checkTabError(VEHICLE_DETAILS_FIELDS),
    [CAR_TABS.DRIVER_AGE_RANGE]:
      checkTabError(DRIVER_AGE_RANGE_FIELDS) || !!driverAgeError,
  }

  const renderTabButton = (element: React.ReactNode, withError: boolean) => {
    if (withError) {
      return (
        <div className={styles['tab-children-error']}>
          {element} <ImportantIcon size="medium" />
        </div>
      )
    }
    return element
  }

  const renderTab = (element: React.ReactNode, tabKey: string) => {
    if (tabKey === CAR_TABS.DETAILS) {
      return renderTabButton(element, tabErrors[tabKey])
    }

    if (tabKey === CAR_TABS.DRIVER_AGE_RANGE) {
      return renderTabButton(element, tabErrors[tabKey])
    }

    return element
  }

  return (
    <div className={styles.container}>
      <Tabs
        activeKey={activeKey}
        onChange={changeActiveKey}
        type="marketplace"
        withoutInitScroll
      >
        {tabs.map((tab) => (
          <TabPane
            id={tab.tab}
            key={tab.key}
            tab={renderTab(tab.tab, tab.key)}
            isError={tabErrors[tab.tab]}
          >
            <div className={styles['tab-children']}>{tab.children}</div>
          </TabPane>
        ))}
      </Tabs>
    </div>
  )
}
